<template>
    <div style="width: 100%;padding: 20px;box-sizing: border-box;">

        <div style="text-align: right;">
            <el-button size="small" type="primary" @click="editClub(null)">+ New Club</el-button>
        </div>

        <el-table :data="dataList" style="margin-top: 20px;" empty-text="No Data" :highlight-current-row="false"
            :highlight-selection-row="false" :header-cell-class-name="'custom-head-cell'"
            :row-class-name="'custom-row-bg'">
            <el-table-column prop="name" label="Club Name"></el-table-column>
            <el-table-column prop="type" label="Club Type"></el-table-column>
            <el-table-column prop="student_count" label="No.of Students"></el-table-column>
            <el-table-column prop="" label="Leader">
                <template slot-scope="scope">
                    <div v-if="scope.row.leader">{{ scope.row.leader.student_lastName_pinyin &&
                        scope.row.leader.student_givenName_pinyin ? scope.row.leader.student_lastName_pinyin + ' ' +
                    scope.row.leader.student_givenName_pinyin : (scope.row.leader.student_lastName + ' ' +
                        scope.row.leader.student_givenName) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="" label="Operation" width="264px">
                <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="actionToClubDetail(scope.row)">Club Dashboard</el-button>
                    <!-- <el-button type="primary" size="small" @click="editClub(scope.row)">Club Info</el-button> -->
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :visible.sync="showClubInfoDialog" :title="clubInfo.id == '' ? 'Add Club' : 'Edit Club'" width="45%">
            <div>
                <el-form :model="clubInfo" :rules="rules" ref="form" label-position="right" label-width="140px">
                    <el-form-item label="Club Name" prop="name">
                        <el-input v-model="clubInfo.name" style="width: 80%;"></el-input>
                    </el-form-item>
                    <el-form-item label="Club Type" prop="type">
                        <el-select v-model="clubInfo.type" placeholder="Please select">
                            <el-option label="Science & Technology" value="Science & Technology"></el-option>
                            <el-option label="Mathematics" value="Mathematics"></el-option>
                            <el-option label="Language & Literature" value="Language & Literature"></el-option>
                            <el-option label="History & Social Studies" value="History & Social Studies"></el-option>
                            <el-option label="Engineering & Robotics" value="Engineering & Robotics"></el-option>
                            <el-option label="Computer Science & Programming" value="Computer Science & Programming"></el-option>
                            <el-option label="Academic Competition" value="Academic Competition"></el-option>
                            <el-option label="Visual Arts" value="Visual Arts"></el-option>
                            <el-option label="Music & Band" value="Music & Band"></el-option>
                            <el-option label="Theater & Drama" value="Theater & Drama"></el-option>
                            <el-option label="Creative Writing" value="Creative Writing"></el-option>
                            <el-option label="Photography" value="Photography"></el-option>
                            <el-option label="Film & Media" value="Film & Media"></el-option>
                            <el-option label="Athletic Teams" value="Athletic Teams"></el-option>
                            <el-option label="Recreational Sports" value="Recreational Sports"></el-option>
                            <el-option label="Outdoor Adventure" value="Outdoor Adventure"></el-option>
                            <el-option label="Chess & Strategy Games" value="Chess & Strategy Games"></el-option>
                            <el-option label="Community Service" value="Community Service"></el-option>
                            <el-option label="Student Government" value="Student Government"></el-option>
                            <el-option label="Honor Society" value="Honor Society"></el-option>
                            <el-option label="Environmental & Sustainability" value="Environmental & Sustainability"></el-option>
                            <el-option label="Cultural Heritage" value="Cultural Heritage"></el-option>
                            <el-option label="International Relations" value="International Relations"></el-option>
                            <el-option label="Language Exchange" value="Language Exchange"></el-option>
                            <el-option label="Social Justice & Advocacy" value="Social Justice & Advocacy"></el-option>
                            <el-option label="Hobby & Interest Groups" value="Hobby & Interest Groups"></el-option>
                            <el-option label="Professional Development" value="Professional Development"></el-option>
                            <el-option label="Religious & Spiritual" value="Religious & Spiritual"></el-option>
                            <el-option label="Health & Wellness" value="Health & Wellness"></el-option>
                            <el-option label="Other" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Club Intro" prop="intro">
                        <el-input v-model="clubInfo.intro" type="textarea" :rows="4" style="width: 80%;"></el-input>
                    </el-form-item>
                </el-form>
                <div style="text-align: right;">
                    <el-button @click="showClubInfoDialog = false">Cancel</el-button>
                    <el-button type="primary" @click="saveClubInfo">Confirm</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    updateClub,
    getAdvisorClubs,
} from '../../api/eclub'
import {
    getUserType,
    getUserId
} from '../../utils/store'
export default ({
    name: 'index',
    data() {
        return {
            user_id: getUserId(),
            dataList: [],
            showClubInfoDialog: false,
            clubInfo: {
                id: '',
                name: '',
                intro: '',
                type: '',
                creator_id: '',
                creator_type: getUserType()
            },
            rules: {
                name: [
                    { required: true, message: 'Please input', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: 'Please select', trigger: 'blur' }
                ],
                intro: [
                    { required: true, message: 'Please input', trigger: 'blur' }
                ],
            },

        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {

        gotoShowClubStudents(club_id) {
            this.$router.push({
                path: '/home/clubstudents',
                query: {
                    club_id: club_id
                }
            })
        },

        editClub(raw) {
            if (raw) {
                this.clubInfo = {
                    id: raw._id.$id,
                    name: raw.name,
                    intro: raw.intro,
                    creator_id: raw.creator_id,
                    type: raw.type,
                    creator_type: raw.creator_type
                }
            } else {
                this.clubInfo = {
                    id: '',
                    name: '',
                    intro: '',
                    creator_id: this.user_id,
                    type: '',
                    creator_type: getUserType()
                }
            }
            this.showClubInfoDialog = true
        },
        saveClubInfo() {
            this.$refs.form.validate((val) => {
                if (val) {
                    updateClub(this.clubInfo).then((res) => {
                        this.$message.success('Update successful')
                        this.fetchData()
                        this.showClubInfoDialog = false
                    })
                }
            })
        },

        fetchData() {
            getAdvisorClubs(this.user_id).then((res) => {
                this.dataList = res.data.data
            })
        },
        tableCellstyle() {
            return 'background:  #FAE3E4;border:1px solid white;text-align:center; font-family: GravityBold;'
        },
        actionToClubDetail(row) {
            this.$router.push({
                path: '/home/clubdetail',
                query: {
                    club_id: row._id.$id
                }
            })
        },
    }
})
</script>
<style scoped lang="scss">
::v-deep  .el-table .custom-row-bg {
    // background: #FF8833;
}

::v-deep  .el-table .custom-head-cell {
    background: #FF8833;
    color: white;
    // text-align: center;
    // border: 1px solid white;
    box-sizing: border-box;
    font-family: GravityBold;
}
</style>